<template lang="html">
  <div class="slide">
    <svg ref="scene" class="canvas" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <clipPath id="clipFrame">
        <rect x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      </clipPath>
      <rect id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <g clip-path="url(#clipFrame)">
        <g class="clouds" :style="{transform: `translateX(${-canvasWidth*2}px)`}">
          <ImageLazy
            :width="canvasWidth*4"
            :height="canvasHeight"
            :srcs= "[
              `${publicPath}scenes/hogan/Clouds-q80-w2000.jpg`,
              `${publicPath}scenes/hogan/Clouds.jpg`
            ]" />
        </g>
      </g>
      <g :transform-origin="`${canvasWidth/2} ${canvasHeight/2}`">
        <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
          <picture>
            <source :srcset="`${publicPath}scenes/hogan/Foreground-480w.png`" media="(max-width: 480px)">
            <source :srcset="`${publicPath}scenes/hogan/Foreground-768w.png`" media="(max-width: 768px)">
            <source :srcset="`${publicPath}scenes/hogan/Foreground-1280w.png`" media="(max-width: 1280px)">
            <source :srcset="`${publicPath}scenes/hogan/Foreground-1920w.png`" media="(max-width: 1920px)">
            <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/hogan/Foreground.png`" />
          </picture>
        </foreignObject>
      </g>
      <g class="grass">
        <image
          :width="canvasWidth" :height="canvasHeight"
          :href="`${publicPath}scenes/hogan/grass/Frame_1-1000x720.png`"
          :xlink:href="`${publicPath}scenes/hogan/grass/Frame_1-1000x720.png`" />
        <image
          :width="canvasWidth" :height="canvasHeight"
          :href="`${publicPath}scenes/hogan/grass/Frame_2-1000x720.png`"
          :xlink:href="`${publicPath}scenes/hogan/grass/Frame_2-1000x720.png`" />
        <image
          :width="canvasWidth" :height="canvasHeight"
          :href="`${publicPath}scenes/hogan/grass/Frame_3-1000x720.png`"
          :xlink:href="`${publicPath}scenes/hogan/grass/Frame_3-1000x720.png`" />
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue" :show="true"
      :width="0.33" :tx="1" :ty="0.5">
      {{ content }}
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/hogan/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import SceneDialogue from "../SceneDialogue.vue"
import SceneAudio from "../SceneAudio.vue"
import Template from "./Template.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  data: () => ({
    publicPath: process.env.BASE_URL,
    canvasWidth: 1000,
    canvasHeight: 720,
    contentWidth: 330,
    contentPadding: 20,
    dy: 0,
    showContent: false,
    content: "Max was born in 1904. His family followed the herds by season, migrating between Shonto and the Canyon lands south of Navajo Mountain, back when Arizona was still a territory. Each year, they would make the journey again.",
    tl: null,
  }),
  props: ["slide"],
  mounted() {
    const d = this.$refs["dialogue"].$el
    // this.tl = new TimelineLite({paused: true, onComplete: this.audioPlay})
    TweenLite.set(this.$refs["scene"], {opacity: 0})
    TweenLite.set(d, {opacity: 0})
    this.tl.add(TweenLite.to(this.$refs["scene"], 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d, 0.5, {opacity: 1}))
  },
  methods: {
    enter() {
      this.tl.play()
    }
  },
  components: {
    SceneDialogue,
    SceneAudio,
  },
}
</script>

<style lang="scss" scoped>
.clouds {
  animation: sky 60s linear infinite;
}
.grass {
  image {
    animation: grass 1s infinite;
    animation-timing-function: steps(0, end);
    &:nth-of-type(1) { animation-delay: 0s; }
    &:nth-of-type(2) { animation-delay: -.25s; }
    &:nth-of-type(3) { animation-delay: -.5s; }
  }
}
@keyframes sky {
  to { transform: translateX(0px); }
}
@keyframes grass {
  0% { opacity: 1 }
  33% { opacity: 0 }
}
</style>
